module.exports = __webpack_public_path__ + "static/media/arrow_right_nospace.0c6f6354.svg";